import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
private readonly DELIMITER = '-'

    public minDate: NgbDateStruct | null
    public maxDate: NgbDateStruct | null

    public parse(value: string): NgbDateStruct | null {
        if (!value) return null

        const dateParts = value.trim().split(this.DELIMITER)

        if (dateParts.length !== 3) return null

        const [day, month, year] = dateParts.map((item) => parseInt(item))

        if (!this.validateInput(day, month, year)) return null

        const date = { day, month, year }

        if (this.minDate && this.isBefore(date, this.minDate)) return null
        if (this.maxDate && this.isAfter(date, this.maxDate)) return null

        return date
    }

    public format(date: NgbDateStruct | null): string {
        const delimiter = this.DELIMITER

        return date
            ? `${this.fillWithZero(date.day)}${delimiter}${this.fillWithZero(date.month)}${delimiter}${date.year}`
            : ''
    }

    private fillWithZero(number: number): string {
        return number.toString().padStart(2, '0')
    }

    private validateInput(day: number, month: number, year: number): boolean {
        return !isNaN(day) && day >= 1 && day <= 31
            && !isNaN(month) && month >= 1 && month <= 12
            && !isNaN(year) && year >= 1900
    }

    private isBefore(a: NgbDateStruct, b: NgbDateStruct): boolean {
        if (a.year !== b.year) return a.year < b.year

        if (a.month !== b.month) return a.month < b.month

        return a.day < b.day
    }

    private isAfter(a: NgbDateStruct, b: NgbDateStruct): boolean {
        if (a.year !== b.year) return a.year > b.year

        if (a.month !== b.month) return a.month > b.month

        return a.day > b.day
    }
}
